// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import router from './router'

Vue.router = router

Vue.config.productionTip = false

window.eventHub = new Vue()

// Localstorage

import VueLocalStorage from 'vue-localstorage'

Vue.use(VueLocalStorage)

// Moment

Vue.use(require('vue-moment'))

// Filters
require('./filters')

// Pusher
Vue.use(require('vue-pusher'), {
    api_key: '5292704ba3fca37f9b11',
    authEndpoint: '/pusher_auth.php',
    options: {
        cluster: 'eu',
        encrypted: true,
    }
})

// Toastr
import VueToastr from '@deveodk/vue-toastr'
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'

Vue.use(VueToastr, {
    defaultPosition: 'toast-top-right',
    defaultType: 'info',
    defaultTimeout: 10000
})

// Tooltip
import VTooltip from 'v-tooltip'

Vue.use(VTooltip)

// Sweet alert
import VueSweetAlert from 'vue-sweetalert'

Vue.use(VueSweetAlert)

// Highcharts

import VueHighcharts from 'vue-highcharts';

Vue.use(VueHighcharts);

// Axios

const axios = require('axios')

import api from './config/api'

const VueAxios = axios.create({
    baseURL: 'https://api.ahotels.dk',
    withCredentials: true,
    paramsSerializer: (params) => {
        return toQueryString(params);$
    }
})

function toQueryString(object, prefix) {
    let string = [], key, value;

    for (var property in object) {
        if (!object.hasOwnProperty(property)) {
            continue;
        }

        key = prefix ? prefix + "[" + property + "]" : property;

        if (~property.indexOf('[')) {
            key = prefix ?
                prefix + "[" + property.substring(0, property.indexOf('[')) + "]" + property.substring(property.indexOf('[')) :
                property;
        }

        value = object[property];
        string.push(
            typeof value == "object" ?
                toQueryString(value, key) :
                encodeURIComponent(key) + "=" + encodeURIComponent(value)
        );
    }

    return string.join("&");
}

Vue.prototype.$http = VueAxios

// Video

var VueVideoPlayer = require('vue-video-player')


// mount with global
Vue.use(VueVideoPlayer)

// Vuex
import store from './store'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js